import React from 'react';
import { Skeleton, Space } from 'antd';
import ChevronIcon from '@dynamika-shared/ui/icons/Chevron';

type ClinicalTrialListLoadingProp = {
  count: number;
  context: string | undefined;
};

export const ClinicalTrialListLoading: React.FC<
  ClinicalTrialListLoadingProp
> = ({ count, context }) => {
  const skeletonArray = Array.from({ length: count }, (_, index) => index);
  return (
    <div className='flex flex-col'>
      {skeletonArray.map(index => {
        return (
          <Space
            key={index}
            className=' flex h-9 items-center justify-between border-t-[1px] border-brightGray p-1'
          >
            <div>
              <Skeleton.Avatar
                active={true}
                size={'large'}
                shape={'circle'}
                className='mr-1'
              />
              <Skeleton.Input active={true} size={'large'} />
            </div>

            {context === 'selectCT' && (
              <ChevronIcon dir={'right'} className='h-3 w-3 text-spanishGray' />
            )}
          </Space>
        );
      })}
    </div>
  );
};

export default ClinicalTrialListLoading;
